/**
 * Maps a `PrintReportSettings` DB row — binds a print-form template (server + report ID)
 * to a specific document type, client, and person combination.
 */
export class PrintReportSetting {
  REPORTID: number;
  CLIID: number;
  PERSID: number;
  LCOCLIID: number;
  DOCTYPE: number;
  REPORTOPT: number;
  REPORTNAME: string;
  REPORTSERVER: string;
  REPORTSRVOPT: string;

  cloneIndex?: number;
  DOCTYPENAME?: string;
  CLIENTNAME?: string;
  PERSONNAME?: string;

}

/**
 * Server connection coordinates for the application: DB, API, auth (Keycloak), and report (jsreport) servers.
 * Values may come from environment config, browser localStorage, or login app_metadata.
 */
export class GlobalConnSettings {

  dbSrvAddress?: string;
  dataBaseName?: string;
  apiSrvAddress?: string;
  dbUserLogin?: string;
  authSrvAddress?: string;
  reportSrvAddress?: string;

  /* new format */

  dbServer?: {
    url: string;
    items: string[];
    dbName: string;
    userLogin: string;
  };

  apiServer?: {
    url: string;
    items: string[];
  };

  authServer?: {
    url: string;
    items: { url: string; clientId: string; }[];
    realm: string;
    clientId: string;
  };

  reportServer?: {
    url?: string;
    items?: string[];
    url1: string;
    items1: string[];
    url2: string;
    items2: string[];
  }
}

/**
 * Per-user application settings loaded from the `SecurityGroupMembers` DB row.
 * Drives stock, currency, department, and VAT defaults for every operation in the session.
 */
export class GlobalSettingsData {

  SGMDESC?: string;
  SGMLOGIN?: string;
  SGMPASSWD?: string;

  accessGroup: number;

  mainCompanyId: number;

  mainPersonId: number;
  vatValue: number;
  mainCurrencyId: number;
  balanceCurrencyId: number;
  viewDCurrencyId: number;
  viewECurrencyId: number;
  mainStockId: number;
  impStockId: number;
  auxStockId: number;
  impCountFlag: boolean;
  auxCountFlag: boolean;
  manDepartmentId: number;
  auxDepartmentId: number;
  paidDepartmentId: number;
  cashDepartmentId: number;

  defaultTradeCompanyId: number;

  urlPrefixString: string;
  constructor(init?: Partial<GlobalSettingsData>) {
    if (init) {
      Object.assign(this, init);
    }
  }

  /** Returns the main stock ID, or `0` if unset. */
  getMainStock(): number { return (this.mainStockId ? this.mainStockId : 0); }

  /** Returns the import stock ID when `impCountFlag` is set, otherwise `0`. */
  getImpStock(): number { return (this.impStockId && this.impCountFlag ? this.impStockId : 0); }
  /** Returns the auxiliary stock ID when `auxCountFlag` is set, otherwise `0`. */
  getAuxStock(): number { return (this.auxStockId && this.auxCountFlag ? this.auxStockId : 0); }

/**
 * Returns a comma-separated depot string for use with getProdAllDepotsStock.
 * Includes only depots that are enabled (non-zero) per the count flags.
 *
 * @example
 * '4258,4259,4260'   // all three active
 * '4258'             // only main stock active
 */
  getDepotString(): string {
    return [this.getMainStock(), this.getImpStock(), this.getAuxStock()]
      .filter(d => d > 0)
      .join(',');
  }

}

